var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "agent-editor-wrapper" },
    [
      _c("div", { staticClass: "header-section" }, [
        _c("div", { staticClass: "back-button", on: { click: _vm.goBack } }, [
          _c("i", { staticClass: "material-icons" }, [_vm._v("arrow_back")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("voiceagent.back")))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "title-wrapper" }, [
          _c("h1", { staticClass: "main-title" }, [
            _vm._v(
              _vm._s(
                _vm.agent
                  ? _vm.agent.agent_name
                  : _vm.$t("voiceagent.voiceAgent")
              )
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.agent
          ? _c("div", { staticClass: "metrics-wrapper" }, [
              _vm.agent.llm
                ? _c(
                    "div",
                    {
                      staticClass: "metric-item prompt-token-metric",
                      staticStyle: {
                        "margin-right": "16px",
                        position: "relative",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "prompt-token-block",
                          class: {
                            "prompt-token-block--warn-hover":
                              _vm.promptTokenOverSurchargeThreshold,
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "prompt-token-count",
                              class: {
                                "prompt-token-count--warn":
                                  _vm.promptTokenOverSurchargeThreshold,
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("voiceagent.promptTokenCount", {
                                    count: _vm.promptTokenCount,
                                  })
                                )
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.promptTokenOverSurchargeThreshold
                            ? _c("div", { staticClass: "prompt-token-warn" }, [
                                _c(
                                  "i",
                                  {
                                    staticClass:
                                      "material-icons prompt-token-warn__icon",
                                    attrs: { "aria-hidden": "true" },
                                  },
                                  [_vm._v("warning")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "prompt-token-warn__panel",
                                    attrs: { role: "tooltip" },
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass: "prompt-token-warn__text",
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.$t(
                                                "voiceagent.promptTokenWarnHallucination"
                                              )
                                            ) +
                                            "\n                            "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass: "prompt-token-warn__text",
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.$t(
                                                "voiceagent.promptTokenWarnSurcharge"
                                              )
                                            ) +
                                            "\n                            "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "prompt-token-warn__divider",
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "prompt-token-warn__price-row",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "prompt-token-warn__label",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "voiceagent.promptTokenTooltipBasePricing"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "prompt-token-warn__price",
                                          },
                                          [
                                            _vm._v(
                                              "$" +
                                                _vm._s(
                                                  _vm.formattedLlmBasePerMin
                                                ) +
                                                _vm._s(
                                                  _vm.$t(
                                                    "voiceagent.perMinuteAbbrev"
                                                  )
                                                )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "prompt-token-warn__estimated",
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.$t(
                                                "voiceagent.promptTokenTooltipEstimatedTokens",
                                                {
                                                  count: _vm.promptTokenCount,
                                                }
                                              )
                                            ) +
                                            "\n                            "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "prompt-token-warn__price-row prompt-token-warn__price-row--emphasis",
                                      },
                                      [
                                        _c("span"),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "prompt-token-warn__price prompt-token-warn__price--accent",
                                          },
                                          [
                                            _vm._v(
                                              "$" +
                                                _vm._s(
                                                  _vm.formattedLlmDisplayPerMin
                                                ) +
                                                _vm._s(
                                                  _vm.$t(
                                                    "voiceagent.perMinuteAbbrev"
                                                  )
                                                )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "metric-item",
                  staticStyle: { "margin-right": "16px", position: "relative" },
                },
                [
                  _c(
                    "a-tooltip",
                    { attrs: { placement: "bottom" } },
                    [
                      _c("template", { slot: "title" }, [
                        _c("div", [
                          _c("b", [
                            _vm._v(_vm._s(_vm.$t("voiceagent.pricePerMinute"))),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(_vm._s(_vm.$t("voiceagent.total")) + ": "),
                          _c("b", [
                            _vm._v(
                              "$" +
                                _vm._s(_vm.totalPricePerMin.toFixed(3)) +
                                _vm._s(_vm.$t("voiceagent.perMinuteAbbrev"))
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticStyle: { "margin-top": "6px" } }, [
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.$t("voiceagent.pricingLlmCost")) +
                                ": $" +
                                _vm._s(_vm.llmPricePerMin.toFixed(3)) +
                                _vm._s(_vm.$t("voiceagent.perMinuteAbbrev"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.$t("voiceagent.pricingVoiceInfra")) +
                                ": $" +
                                _vm._s(_vm.voiceInfraPricePerMin.toFixed(3)) +
                                _vm._s(_vm.$t("voiceagent.perMinuteAbbrev"))
                            ),
                          ]),
                          _vm._v(" "),
                          !_vm.isRealtimeModel
                            ? _c("div", [
                                _vm._v(
                                  _vm._s(_vm.$t("voiceagent.pricingTtsCost")) +
                                    ": $" +
                                    _vm._s(_vm.ttsPricePerMin.toFixed(3)) +
                                    _vm._s(_vm.$t("voiceagent.perMinuteAbbrev"))
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("voiceagent.pricingTelephonyCost")
                              ) +
                                ": $" +
                                _vm._s(_vm.telephonyPricePerMin.toFixed(3)) +
                                _vm._s(_vm.$t("voiceagent.perMinuteAbbrev"))
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.hasKnowledgeBase
                            ? _c("div", [
                                _vm._v(
                                  _vm._s(_vm.$t("voiceagent.knowledgeBase")) +
                                    ": $" +
                                    _vm._s(_vm.kbPricePerMin.toFixed(4)) +
                                    _vm._s(_vm.$t("voiceagent.perMinuteAbbrev"))
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-weight": "500",
                            cursor: "pointer",
                          },
                        },
                        [
                          _c(
                            "i",
                            {
                              staticClass: "material-icons",
                              staticStyle: {
                                "vertical-align": "middle",
                                color: "#1890ff",
                              },
                            },
                            [_vm._v("attach_money")]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticStyle: { "vertical-align": "middle" } },
                            [
                              _vm._v(
                                "$" +
                                  _vm._s(_vm.totalPricePerMin.toFixed(3)) +
                                  _vm._s(_vm.$t("voiceagent.perMinuteAbbrev"))
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "metric-item",
                  staticStyle: { position: "relative" },
                },
                [
                  _c(
                    "a-tooltip",
                    { attrs: { placement: "bottom" } },
                    [
                      _c("template", { slot: "title" }, [
                        _c("div", [
                          _c("b", [
                            _vm._v(
                              _vm._s(_vm.$t("voiceagent.estimatedLatency"))
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(_vm._s(_vm.$t("voiceagent.total")) + ": "),
                          _c("b", [_vm._v(_vm._s(_vm.totalLatencyText))]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticStyle: { "margin-top": "6px" } }, [
                          !_vm.isRealtimeModel
                            ? _c("div", [
                                _vm._v(
                                  _vm._s(_vm.$t("voiceagent.latencyTts")) +
                                    ": 450 ms"
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.$t("voiceagent.latencyLlm")) +
                                ": " +
                                _vm._s(_vm.llmLatencyText)
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.$t("voiceagent.transcription")) +
                                ": 100-300 ms"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.$t("voiceagent.latencyTelephony")) +
                                ": 100 ms"
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.hasKnowledgeBase
                            ? _c("div", [
                                _vm._v(
                                  _vm._s(_vm.$t("voiceagent.knowledgeBase")) +
                                    ": 75-125 ms"
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-weight": "500",
                            cursor: "pointer",
                          },
                        },
                        [
                          _c(
                            "i",
                            {
                              staticClass: "material-icons",
                              staticStyle: {
                                "vertical-align": "middle",
                                color: "#faad14",
                              },
                            },
                            [_vm._v("timer")]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticStyle: { "vertical-align": "middle" } },
                            [_vm._v(_vm._s(_vm.totalLatencyText))]
                          ),
                        ]
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("a-spin", { attrs: { spinning: _vm.loading } }, [
        _c("div", { staticClass: "custom-tabs" }, [
          _c(
            "div",
            { staticClass: "tabs-header" },
            _vm._l(_vm.tabs, function (tab) {
              return _c(
                "div",
                {
                  key: tab.key,
                  staticClass: "tab-item",
                  class: { active: _vm.currentTab === tab.key },
                  on: {
                    click: function ($event) {
                      _vm.currentTab = tab.key
                    },
                  },
                },
                [
                  _c("span", [_vm._v(_vm._s(tab.label))]),
                  _vm._v(" "),
                  tab.key === "web-agent"
                    ? _c("span", { staticClass: "beta-ribbon" }, [
                        _vm._v(_vm._s(_vm.$t("voiceagent.beta"))),
                      ])
                    : _vm._e(),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tab-content" },
            [
              _vm.currentTab === "agent"
                ? _c("AgentTab", {
                    attrs: { agent: _vm.agent },
                    on: {
                      update: _vm.updateAgent,
                      "llm-updated": _vm.handleLLMUpdated,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.currentTab === "functions"
                ? _c("FunctionsTab", {
                    attrs: { agent: _vm.agent },
                    on: {
                      update: _vm.updateAgent,
                      "llm-updated": _vm.handleLLMUpdated,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.currentTab === "knowledge-base"
                ? _c("KnowledgeBaseTab", {
                    attrs: { agent: _vm.agent },
                    on: {
                      update: _vm.updateAgent,
                      "llm-updated": _vm.handleLLMUpdated,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.currentTab === "speech-settings"
                ? _c("SpeechSettingsTab", {
                    attrs: { agent: _vm.agent },
                    on: { update: _vm.updateAgent },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.currentTab === "call-settings"
                ? _c("CallSettingsTab", {
                    attrs: { agent: _vm.agent },
                    on: { update: _vm.updateAgent },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.currentTab === "security-fallback"
                ? _c("SecurityFallbackSettingsTab", {
                    attrs: { agent: _vm.agent },
                    on: {
                      update: _vm.updateAgent,
                      "llm-updated": _vm.handleLLMUpdated,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.currentTab === "web-agent"
                ? _c("WebAgentTab", {
                    attrs: { agent: _vm.agent },
                    on: { update: _vm.updateAgent },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }